const BookingActions = ({ onViewDetails }) => {
    return (
        <button
            onClick={(e) => {
                e.stopPropagation();
                onViewDetails();
            }}
            className="px-3 py-1.5 rounded-lg text-xs font-semibold text-[#067978] bg-teal-50 hover:bg-[#067978] hover:text-white border border-teal-100/80 hover:border-[#067978] transition-all duration-200 whitespace-nowrap cursor-pointer active:scale-95 shadow-2xs"
            title="View Details"
            type="button"
        >
            View Details
        </button>
    );
};

export default BookingActions;
